function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Tabs, notification, Drawer, Modal, List, Space, Button, Table, DatePicker, Divider, Spin, Breadcrumb } from "antd";
import { ListUl, Cash, Plus, PencilSquare, ThreeDots, Shop } from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import moment from 'moment';
import ShopIcon from '@iconify-react/flat-color-icons/shop';
import Common from "../components/includes/Common";
import dayjs from 'dayjs';
import ProvisionHistory from "../components/ProvisionHistory";
import AddShop from "../components/forms/AddShop";
import ShowPosDetails from "../components/ShowPosDetails";
import EditShop from "../components/forms/EditShop";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Shops = function Shops() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    refresh = _useState2[0],
    setRefresh = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    pointsOfSale = _useState4[0],
    setPointsOfSale = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    payoutsDataChanged = _useState8[0],
    setPayoutsDataChanged = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    dataError = _useState0[0],
    setDataError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showAddPos = _useState12[0],
    setShowAddPos = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showPosDetails = _useState14[0],
    setShowPosDetails = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEditPos = _useState16[0],
    setShowEditPos = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedPos = _useState18[0],
    setSelectedPos = _useState18[1];
  useEffect(function () {
    setRefresh(false);
    setDataChanged(false);
    setIsDataLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getpointsofsale/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setPointsOfSale([]);
        response[0].data.pointsofsale.forEach(function (p) {
          setPointsOfSale(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: p.label,
              address: p.address,
              mobile: p.mobile,
              balance: p.balance,
              action: p
            }]);
          });
        });
      } else {
        setDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [refresh, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Breadcrumb, {
          items: [{
            title: /*#__PURE__*/_jsx("span", {
              children: "ALO-GAZ"
            })
          }, {
            title: "Points de vente"
          }]
        }), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        lg: 10,
        md: 10,
        sm: 12,
        children: [/*#__PURE__*/_jsx(Space, {
          direction: "horizontal",
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            icon: /*#__PURE__*/_jsx(Plus, {}),
            onClick: function onClick() {
              setShowAddPos(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: " CREER UNE BOUTIQUE"
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Table, {
          size: "small",
          columns: [{
            title: /*#__PURE__*/_jsx("b", {
              children: "Nom"
            }),
            dataIndex: "label",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "label"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Adresse"
            }),
            dataIndex: "address",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "address"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "T\xE9l\xE9phone"
            }),
            dataIndex: "mobile",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "mobile"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Solde"
            }),
            dataIndex: "balance",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v.toLocaleString('Fr')
              });
            },
            key: "balance"
          }, {
            title: /*#__PURE__*/_jsx("b", {}),
            dataIndex: "action",
            render: function render(p) {
              return /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "default",
                  onClick: function onClick() {
                    setSelectedPos(p);
                    setShowEditPos(true);
                  },
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PencilSquare, {}), " MODIFIER"]
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  onClick: function onClick() {
                    setSelectedPos(p);
                    setShowPosDetails(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(ThreeDots, {})
                  })
                })]
              });
            },
            key: "action"
          }],
          bordered: true,
          sticky: true,
          loading: isDataLoading,
          dataSource: pointsOfSale,
          scroll: {
            y: 520
          }
        })]
      }), /*#__PURE__*/_jsx(Col, {})]
    }), showAddPos && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(ShopIcon, {
          height: "26px"
        }), " Ajouter une boutique"]
      }),
      open: showAddPos,
      onCancel: function onCancel() {
        setShowAddPos(false);
      },
      destroyOnClose: true,
      footer: null,
      width: {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddShop, {
        handler: function handler() {
          setDataChanged(true);
          setShowAddPos(false);
          notification.success({
            message: "Ok!",
            description: "Opération réussie"
          });
        }
      })
    }), selectedPos && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(ShopIcon, {
            height: "26px"
          }), " DETAILS POINT DE VENTE"]
        }),
        open: showPosDetails,
        onClose: function onClose() {
          setShowPosDetails(false);
        },
        destroyOnClose: true,
        width: "390px",
        children: /*#__PURE__*/_jsx(ShowPosDetails, {
          pos: selectedPos,
          handler: function handler() {
            setDataChanged(true);
            setShowPosDetails(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(PencilSquare, {
            height: "26px"
          }), " MODIFIER UN POINT DE VENTE"]
        }),
        open: showEditPos,
        onCancel: function onCancel() {
          setShowEditPos(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(EditShop, {
          pos: selectedPos,
          handler: function handler() {
            setDataChanged(true);
            setShowEditPos(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie"
            });
          }
        })
      })]
    })]
  });
};
export default Shops;